/**
 * FinCore LocalDate JSON is compact yyyyMMdd, not ISO-8601.
 * Uses the local calendar so toISOString() cannot shift the day west of UTC.
 */
export function toIsoLocalDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
}

export function toCalendarMonthFromReference(referenceDate: Date): string {
  return toIsoLocalDate(
    new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 1)
  );
}

export function isValidBfeeGroupId(bfeeGroupId: number): boolean {
  return Number.isFinite(bfeeGroupId) && bfeeGroupId >= 1;
}

export function emailReportMessage(emailSent: boolean): string {
  return emailSent
    ? 'Report emailed.'
    : 'Email report was not sent (check server mail configuration).';
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Added FinCore date helpers toIsoLocalDate() and toCalendarMonthFromReference(), plus isValidBfeeGroupId() and emailReportMessage(). Previous behavior: No shared formatter existed; ISO toISOString() can shift the calendar day in timezones west of UTC. New behavior: Dates are formatted as yyyyMMdd from local year/month/day; calendar month is the first day of the month containing referenceDate; BFeeGroup ids must be finite and >= 1; email copy matches FinCore UI. Reason: FinCore Jackson LocalDate is yyyyMMdd and backend processes first-of-month. Context: FinCore REST API V1.000 replication guide. Impact: Services and future UI can share formatting without duplicating timezone-sensitive date logic. - 2026-08-20 - HE
